export default __webpack_public_path__ + "static/media/zhengfu.a711d393.png";